import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import { useFormik } from 'formik';
import { useSelector, useDispatch } from 'react-redux'

// Services

import { clienteDataParcial, cleanUpClienteDataParcial, handleResetFormSteps } from '../../../store/forms/forms.actions';
import { generateTheOtpCode, validateTheOtpCode, cleanUpOtpState } from '../../../store/otp/otp.actions';

// Components

import SectionHeading from '../../UI/SectionHeading/SectionHeading';
import CodeInput from '../../UI/FormInput/CodeInput';
import Button from '../../UI/Button/Button';

// Validation

import { validationSchema } from './ValidationSchema';

// Utilities

import { handleClientPartialDataRedirect } from '../../../utilities/helper-functions';

export default function AccessCodeForm({ setShowForm, userPhone, userEmail }) {
  const [count, setCount] = useState(120);
  const navigate = useNavigate();
  const generate = useSelector((state) => state.otp.generate);
  const validate = useSelector((state) => state.otp.validate);
  const consultClientPartialData = useSelector((state) => state.forms.consultClientPartialData);
  const dispatch = useDispatch();

  // Setup form with formik

  const formik = useFormik({
    initialValues: { username: userEmail, otp: '' },
    validationSchema: validationSchema,
    onSubmit: (values, actions) => {
      handleValidateOtp(values, actions);
    },
  });

  useEffect(() => {
    dispatch(handleResetFormSteps());
    dispatch(cleanUpClienteDataParcial());
  }, [dispatch]);

  useEffect(() => {
    const timer = count > 0 && setInterval(() => setCount(count - 1), 1000);
    return () => clearInterval(timer);
  }, [count]);


  // Validate OTP

  const handleValidateOtp = async (values, actions) => {
    const data = {
      destinationMail: userEmail,
      token: values.otp
    }
    dispatch(validateTheOtpCode(data));
  }

  // Send OTP

  const handleGenerateOtp = async () => {
    const data = {
      destinationMail: userEmail,
    }

    dispatch(generateTheOtpCode(data));
  }

  // Handle Consult Client Partial Data

  const handleConsultClientPartialData = useCallback(() => {
    const data = {
      email: userEmail,
    }

    dispatch(clienteDataParcial(data));
  }, []);

  useEffect(() => {
    if (validate?.otpValid) {
      handleConsultClientPartialData();
    }
  }, [validate, dispatch])

  useEffect(() => {
    if (generate.otpSent) {
      setCount(120);
    }
  }, [generate])

  useEffect(() => {
    if (consultClientPartialData?.data && validate?.otpValid) {
      localStorage.setItem('clientEmail', userEmail);
      localStorage.setItem('clientPhone', userPhone);
      dispatch(cleanUpOtpState());
      handleClientPartialDataRedirect(consultClientPartialData?.data?.data, navigate);
    }
  }, [consultClientPartialData, validate]);


  return (
    <form onSubmit={formik.handleSubmit}>

      {/* Form Fields */}

      <SectionHeading text={'Clave dinámica'} headingAlt={true} />

      <p className='form-paragraph'>Ingresa el código de seguridad que enviamos a tu correo electrónico <strong>{userEmail}</strong>.</p>

      {/* Form Error Message */}

      {(validate?.error || generate?.error || consultClientPartialData?.error) &&
        <p className="form-error-message">{validate?.error || generate?.error || consultClientPartialData?.error}</p>}

      <p className='form-code-expiration'>Tu clave expira en <strong>{count}</strong> segundos</p>

      <CodeInput
        formik={formik}
        fieldName={'otp'}
      />

      <button
        onClick={() => handleGenerateOtp()}
        type='button'
        className='btn-link btn-link-alt'
        disabled={generate?.isLoading}
      >
        {generate?.isLoading &&
          <span>Reenviando la clave...</span>}

        {!generate?.isLoading &&
          <span>¿No recibiste la clave? <strong>Reenviar</strong></span>}
      </button>

      <div className='form-actions'>

        <Button
          type="submit"
          action={formik.handleSubmit}
          label={'Enviar'}
          additionalStyles={{ width: '100%', margin: 0, marginBottom: '1rem' }}
          disabled={!(formik.isValid && formik.dirty)}
          isLoading={validate?.isLoading || consultClientPartialData?.isLoading}
        />

        <Button
          type="button"
          action={() => { dispatch(cleanUpOtpState()); setShowForm('register') }}
          label={'Regresa'}
          additionalStyles={{ width: '100%', margin: 0 }}
          secondaryStyle={true}
        />

      </div>

    </form>
  )
}